import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import EkycModal from "./EkycModal";
import {
  checkEmailAsync,
  checkMobileAsync,
  createUserAsync,
  fetchDistrictDataAsync,
  fetchIdProofDataAsync,
  fetchStateDataAsync,
  resetisMobileVerified,
  selectDistrictOptions,
  selectError,
  selectIdProofOptions,
  selectStateOptions,
  selectStatus,
  setisMobileVerified,
} from "../auth/authSlice";
import {
  fetchGender,
  fetchIDTypeData,
  fetchPartySignUpDetails,
  fetchRelationData,
  resetConfirmed,
  selectAdhaarEkyc,
  selectConfirmed,
  selectPartySignUpDetails,
} from "../PartyDetail/PartyDetailSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearAadhaarDetails,
  selectAadhaarDetails,
  selectIsOTPVerified,
} from "../property/AadhaarDetailsSlice";
import RegistrationSuccessModal from "./RegistrationSuccessModal";
import { fetchOTPs } from "./modalSlices/MobileEmailModalSlice";
import MobileEmailModal from "./MobileEmailModal";
import { toast } from "react-toastify";

const PartySignUpModal = ({
  isOpen,
  onClose,
  isPartySignUpModify,
  reEkyc,
  setIsPartySignUpModify,
}) => {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const [selectedOption, setSelectedOption] = useState("without");
  const [isEkycModalOpen, setIsEkycModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stateOptions = useSelector(selectStateOptions);
  // const idProofOptions = useSelector(selectIdProofOptions);
  const { idTypeData } = useSelector((state) => state.PartyDetail);
  const districtOptions = useSelector(selectDistrictOptions);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [pincode, setpincode] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [showIdentificationError, setShowIdentificationError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const error = useSelector(selectError);
  const status = useSelector(selectStatus);
  const [country, setCountry] = useState("");
  const { relationData, genderData } = useSelector(
    (state) => state.PartyDetail
  );

  const isOTPVerified = useSelector(selectIsOTPVerified);
  const aadhaarDetails = useSelector(selectAadhaarDetails);
  const [Aadhaar_ekyc, setAadhaar_ekyc] = useState("N");
  const identificationType = watch("identificationType");
  const PartySignUpDetails = useSelector(selectPartySignUpDetails);
  const selectedState = watch("state");
  // const confirmed = useSelector(selectConfirmed);
  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );
  const adhaarEkyc = useSelector(selectAdhaarEkyc);
  const [isMobileAdhaarModalOpen, setisMobileAdhaarModalOpen] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [whatsappVerified, setWhatsappVerified] = useState(false);
  const [requireWhatsapp, setRequireWhatsapp] = useState(false);
  const [isVerificationComplete, setIsVerificationComplete] = useState(false);
  const [formData, setFormData] = useState({}); // Store form data
  const [uploadPhoto, setuploadPhoto] = useState("");

  useEffect(() => {
    dispatch(fetchStateDataAsync());
    dispatch(fetchIDTypeData());
    dispatch(fetchRelationData());
    dispatch(fetchGender());
  }, [dispatch]);

  useEffect(() => {
    if (selectedState) {
      dispatch(fetchDistrictDataAsync(selectedState));
    }
  }, [dispatch, selectedState]);

  useEffect(() => {
    if (
      aadhaarDetails &&
      aadhaarDetails.district &&
      districtOptions.length > 0
    ) {
      const districtID = districtOptions.find(
        (district) =>
          district.districtName.toLowerCase() ===
          aadhaarDetails.district.toLowerCase()
      )?.districtID;

      if (districtID) {
        setValue("district", districtID);
      }
    }
  }, [aadhaarDetails, districtOptions, setValue]);

  useEffect(() => {
    if (appointmentType === "V" || appointmentType === "VI" || reEkyc) {
      setSelectedOption("with");
    }
  }, [selectedOption, appointmentType, reEkyc]);

  useEffect(() => {
    //;
    if (
      isOTPVerified === false &&
      !(appointmentType === "V" || appointmentType === "VI" || reEkyc)
    ) {
      setSelectedOption("without"); // Reset to "without" if modal is closed without completing e-KYC
    }
    if (isOTPVerified === true) {
      setSelectedOption("with");
    }
  }, [isOTPVerified, appointmentType, selectedOption, reEkyc]);

  // Central validation patterns/messages
  const regexPatterns = {
    "01": {
      pattern: /^[A-Z]{3}[0-9]{7}$/,
      message: "Enter a valid Voter ID (3 letters + 7 digits)",
    },
    "02": {
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
      message: "Enter a valid PAN (ABCDE1234F)",
    },
    "03": {
      pattern: /^[A-Z]{2}[0-9]{13}$/,
      message: "Enter a valid Driving Licence (2 letters + 13 digits)",
    },
    "04": {
      pattern: /^[0-9]{12}$/,
      message: "Enter a valid 12-digit Aadhaar number",
    },
    mobile: {
      pattern: /^[0-9]{10}$/,
      message: "Enter a valid 10-digit mobile number",
    },
    email: {
      pattern:
        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[A-Za-z]{2,})+$/,
      message: "Enter a valid email",
    },
  };

  function validateAll(data) {
    // Mobile
    if (!regexPatterns.mobile.pattern.test(data.MobileNo)) {
      toast.error(regexPatterns.mobile.message);
      return false;
    }
    // if (!regexPatterns.mobile.pattern.test(data.WhatsApp_No)) {
    //   toast.error(regexPatterns.mobile.message.replace("mobile", "WhatsApp"));
    //   return false;
    // }
    if (data.WhatsApp_No) {
      if (!regexPatterns.mobile.pattern.test(data.WhatsApp_No)) {
        toast.error("Enter a valid 10-digit WhatsApp number");
        return false;
      }
    }
    // Email
    if (!regexPatterns.email.pattern.test(data.email)) {
      toast.error(regexPatterns.email.message);
      return false;
    }
    // Identification
    const rule = regexPatterns[data.identificationType];
    if (rule && !rule.pattern.test(data.identificationNumber)) {
      toast.error(rule.message);
      return false;
    }
    return true;
  }

  const handleEkycModalClose = (e) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    console.log("Closing modal");
    // setIsEkycModalOpen(false);
    if (
      (appointmentType === "V" || appointmentType === "VI") &&
      isOTPVerified === false
    ) {
      setIsEkycModalOpen(false);
      dispatch(resetisMobileVerified());
      dispatch(resetConfirmed());
      onClose(); // Close PartySignUpModal as well
    } else if (
      (appointmentType === "V" || appointmentType === "VI") &&
      isOTPVerified === true
    ) {
      setIsEkycModalOpen(false);
    }
    if (reEkyc && isOTPVerified === false) {
      setIsEkycModalOpen(false);
      dispatch(resetisMobileVerified());
      dispatch(resetConfirmed());
      onClose(); // Close PartySignUpModal as well
    } else if (reEkyc && isOTPVerified === true) {
      setIsEkycModalOpen(false);
    } else {
      setIsEkycModalOpen(false);
    }
  };

  useEffect(() => {
    //;
    if (selectedOption === "with" && isOTPVerified === false) {
      setIsEkycModalOpen(true);
    } else if (selectedOption === "with" && isOTPVerified === true) {
      setIsEkycModalOpen(false);
    }
  }, [selectedOption, isEkycModalOpen, isOTPVerified]);

  useEffect(() => {
    if (selectedOption === "without") {
      setAadhaar_ekyc("N");
      dispatch(clearAadhaarDetails());
      reset(); // Clear form values
    }
  }, [dispatch, selectedOption]);

  useEffect(() => {
    if (isOTPVerified && aadhaarDetails && selectedOption === "with") {
      const isModify = isPartySignUpModify;
      const rekyc = reEkyc;
      setAadhaar_ekyc("Y");
      setIsEkycModalOpen(false);
      // Avoid re-triggering for the same selected option
      if (selectedOption !== "with") {
        setSelectedOption("with");
      }

      // Format DOB
      const formattedDOB = aadhaarDetails.dob
        ? aadhaarDetails.dob.split("-").reverse().join("-")
        : "";

      setValue("identificationType", "04");
      setValue("identificationNumber", aadhaarNumber || "");
      setValue("DOB", formattedDOB || "");

      // Set modify-specific values only when necessary
      if ((isModify || rekyc) && PartySignUpDetails?.length) {
        const partyDetails = PartySignUpDetails[0];
        setValue("MobileNo", partyDetails?.mobileNo || "");
        setValue("WhatsApp_No", partyDetails?.whatsApp_No || "");
        setValue("username", partyDetails?.username || "");
        setValue("category", partyDetails?.category || "");
        setValue("Relegion", partyDetails?.relegion || "");
        setValue("email", partyDetails?.email || "");
      }

      // Map Aadhaar details only if they change
      Object.entries(aadhaarDetails).forEach(([key, value]) => {
        setValue(key, value || "");
      });
      // Handle state mapping
      const stateID = stateOptions.find(
        (state) =>
          state.stateName.toLowerCase() === aadhaarDetails.state.toLowerCase()
      )?.stateID;
      const districtID = districtOptions.find(
        (district) =>
          district.districtName.toLowerCase() ===
          aadhaarDetails.district.toLowerCase()
      )?.districtID;
      setValue("state", stateID);
      setValue("district", districtID);

      // Map relation
      if (aadhaarDetails.relation) {
        const selectedRelation = relationData.find(
          (relation) =>
            relation.relation?.toLowerCase() ===
            aadhaarDetails.relation?.toLowerCase()
        );
        if (selectedRelation) {
          setValue("relation", selectedRelation.relatioN_CODE);
        } else {
          console.error(
            "Relation not found in relationData:",
            aadhaarDetails.relation
          );
        }
      }

      // Map gender
      if (aadhaarDetails.gender) {
        const mappedGenderCode =
          aadhaarDetails.gender === "M"
            ? "01"
            : aadhaarDetails.gender === "F"
            ? "02"
            : "";
        setValue("gender", mappedGenderCode || "");
      }
    }
  }, [
    aadhaarDetails,
    isOTPVerified,
    selectedOption,
    isPartySignUpModify,
    stateOptions,
    districtOptions,
    relationData,
    PartySignUpDetails,
    dispatch,
  ]);

  const handleAadhaarNumberChange = (number) => {
    setAadhaarNumber(number);
    console.log("Received Aadhaar Number from Modal:", number);
  };

  const handleModify = async (data) => {
    console.log(data);

    try {
      if (selectedOption === "with" && isPartySignUpModify === true) {
        const Aadhaar_ekyc = "Y";
        const userData = {
          ...data,
          Aadhaar_ekyc,
          Photo: data.photo,
          state: String(data.state), // Convert state ID to string
          district: String(data.district), // Convert district ID to string
          role: "1",
          status: "",
        };
        const insertUserResponse = await dispatch(createUserAsync(userData));
        console.log(insertUserResponse);
        if (insertUserResponse.payload.status === 200) {
          // If response contains a payload, assume success
          toast.success("User updated successfully!");

          // Clear input fields
          reset(); // This resets all form fields to their default values
          // Fetch user details by email (assuming email is available in a variable)
          if (data.email) {
            dispatch(fetchPartySignUpDetails(data.email))
              .then((response) => {
                console.log("User details fetched successfully:", response);
              })
              .catch((error) => {
                console.error("Failed to fetch user details:", error);
              });
          }
          onClose();
        } else {
          console.error("Failed to Update user");
          toast.error("Failed to Update user");
        }
      } else {
        // Mobile number already registered, show error message
        // You can dispatch an action to set an error message here if needed
        console.error("Mobile number already registered");
        toast.error("Mobile number already registered");
      }
    } catch (error) {
      // Handle any errors that occur during the API calls
      console.error("Error:", error);
      toast.error("Error:", error);
      // You can dispatch an action to set an error message here if needed
    }
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    if (!validateAll(data)) return;
    const requiredFields = [
      "firstName",
      "lastName",
      "gender",
      "DOB",
      "MobileNo",
      // "WhatsApp_No",
      "email",
      "identificationType",
      "identificationNumber",
      "relation",
      "fatherName",
      "category",
      "Relegion",
      "country",
      "state",
      "district",
      "villageTownCity",
      "house",
      "landmark",
      "street",
      "pincode",
      "username",
      "password",
      "confirmPassword",
    ]; // Replace with actual field names
    const missingFields = requiredFields.filter((field) => !data[field]);
    if (missingFields.length > 0) {
      // Display error messages for missing fields
      missingFields.forEach((field) => {
        setError(field, { type: "manual", message: `${field} is required` });
      });
      return; // Stop form submission
    }

    setFormData(data); // Save form data before verification

    if (!isVerificationComplete) {
      dispatch(
        fetchOTPs({
          mobile: data.MobileNo,
          email: data.email,
          firstName: data.firstName,
          whatsappNo: data?.WhatsApp_No,
        })
      );
      setisMobileAdhaarModalOpen(true); // Open the modal for verification
      return; // Do not continue until verification is done
    }

    // Continue with form submission logic once verification is complete
    handleFormSubmit(data);
  };

  const handleFormSubmit = async (data) => {
    const { email, MobileNo } = data;
    console.log(data);

    try {
      // Check if the email is already registered
      const emailResponse = await dispatch(checkEmailAsync(email));
      console.log(emailResponse);

      if (emailResponse.payload.exists === false) {
        // Email is available, proceed to check mobile number
        const mobileResponse = await dispatch(checkMobileAsync(MobileNo));
        console.log(mobileResponse);
        if (mobileResponse.payload.exists === false) {
          if (selectedOption === "without") {
            const userData = {
              ...data,
              Aadhaar_ekyc,
              role: "",
              status: "",
              Photo: uploadPhoto,
            };
            const insertUserResponse = await dispatch(
              createUserAsync(userData)
            );
            const { statusCode, message } = insertUserResponse.payload;
            if (insertUserResponse.payload.statusCode === "200") {
              // If response contains a payload, assume success
              toast.success("User added successfully!");

              // Clear input fields
              reset(); // This resets all form fields to their default values
              if (data.email) {
                dispatch(fetchPartySignUpDetails(data.email))
                  .then((response) => {
                    console.log("User details fetched successfully:", response);
                  })
                  .catch((error) => {
                    console.error("Failed to fetch user details:", error);
                  });
              }
              onClose();
            } else {
              console.error("Failed to register user");
              toast.error(
                message ?? "User registration failed. Please try again."
              );
            }
          }
          if (selectedOption === "with") {
            const userData = {
              ...data,
              Aadhaar_ekyc,
              state: String(data.state), // Convert state ID to string
              district: String(data.district), // Convert district ID to string
              role: "1",
              status: "",
            };
            const insertUserResponse = await dispatch(
              createUserAsync(userData)
            );

            const { statusCode, message } = insertUserResponse.payload;
            console.log(insertUserResponse);
            if (insertUserResponse.payload.statusCode === "200") {
              // If response contains a payload, assume success
              toast.success("User added successfully!");

              // Clear input fields
              reset(); // This resets all form fields to their default values
              // Fetch user details by email (assuming email is available in a variable)
              if (data.email) {
                dispatch(fetchPartySignUpDetails(data.email))
                  .then((response) => {
                    console.log("User details fetched successfully:", response);
                  })
                  .catch((error) => {
                    console.error("Failed to fetch user details:", error);
                  });
              }
              onClose();
            } else {
              console.error("Failed to register user");
              toast.error(
                message ?? "User registration failed. Please try again."
              );
            }
          }
        } else {
          // Mobile number already registered, show error message
          // You can dispatch an action to set an error message here if needed
          console.error("Mobile number already registered");
          toast.error("Mobile number already registered");
        }
      } else {
        // Email already registered, show error message
        // You can dispatch an action to set an error message here if needed
        console.error("Email already registered");
        toast.error("Email already registered");
      }
    } catch (error) {
      // Handle any errors that occur during the API calls
      console.error("Error:", error);
      toast.error("Error:", error);
      // You can dispatch an action to set an error message here if needed
    }
  };

  const handleFileChange = (event) => {
    debugger;
    const file = event.target.files[0]; // pick the first file
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

    // check format
    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, and PNG formats are allowed.");
      event.target.value = ""; // reset input
      return;
    }

    // convert to base64
    const reader = new FileReader();
    reader.onloadend = () => {
      debugger;
      setuploadPhoto(reader.result); // ✅ save base64 string in state
      console.log("Base64 Image:", reader.result);
    };
    reader.onerror = (error) => {
      console.error("Error converting file to base64:", error);
    };

    reader.readAsDataURL(file);
  };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    if (value === "with") {
      setIsEkycModalOpen(true); // Open e-KYC modal
    }
  };
  const handleVerificationStatusChange = (mobile, email, whatsapp) => {
    setMobileVerified(mobile);
    setEmailVerified(email);
    setWhatsappVerified(whatsapp);
  };
  const onVerificationComplete = () => {
    // Mark verification as complete when all verifications are done
    setIsVerificationComplete(true);
  };
  const onSubmitModal = () => {
    // Close the modal when verification is complete
    setisMobileAdhaarModalOpen(false);
    handleFormSubmit(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-gray-100 rounded-lg shadow-lg p-8 w-full max-w-5xl relative max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={() => {
            dispatch(resetConfirmed());
            dispatch(setisMobileVerified(false));
            onClose();
          }}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-800 text-lg"
        >
          ✖
        </button>

        {/* Modal Header */}
        <h2 className="text-2xl font-bold mb-6 text-center text-blue-600">
          Party Registration Form
        </h2>

        {/* Form Content */}
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        <form
          onSubmit={handleSubmit(isPartySignUpModify ? handleModify : onSubmit)}
        >
          {/* Radio Buttons Section */}
          <div className="mb-6 flex items-center gap-6 pl-4 border-b-2">
            <label className="flex items-center text-gray-700">
              <input
                type="radio"
                name="ekycOption"
                value="without"
                checked={selectedOption === "without"}
                onChange={handleRadioChange}
                disabled={appointmentType === "V" || appointmentType === "VI"}
                className="mr-2"
              />
              Without e-KYC
            </label>
            <label className="flex items-center text-gray-700">
              <input
                type="radio"
                name="ekycOption"
                value="with"
                checked={selectedOption === "with"}
                onChange={handleRadioChange}
                className="mr-2"
              />
              With e-KYC
            </label>
          </div>

          {errors.ekyc && (
            <p className="text-red-500 text-sm mb-4 text-center">
              {errors.ekyc.message}
            </p>
          )}

          {/* Name Fields */}
          <div className="mb-4">
            <div className="grid grid-cols-5 gap-4 items-start">
              {/* Name Field */}
              <div className="col-span-3">
                <label className="block text-sm font-semibold mb-2">
                  Name:
                </label>
                <div className="grid grid-cols-3 gap-2">
                  {/* First Name */}
                  <input
                    className="custom-input"
                    id="firstName"
                    {...register("firstName", {
                      required: "First Name is required",
                      pattern: {
                        value: /^[A-Za-z]+$/,
                        message: "First Name can contain only letters",
                      },
                    })}
                    type="text"
                    placeholder="First Name"
                    required
                    // 1) Strip anything that’s not A–Z or a–z
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^A-Za-z]/g, "");
                    }}
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-xs mt-1 ml-1">
                      {errors.firstName.message}
                    </p>
                  )}

                  {/* Middle Name */}
                  <input
                    className="custom-input"
                    type="text"
                    {...register("middleName", {
                      pattern: {
                        value: /^[A-Za-z]+$/,
                        message: "First Name can contain only letters",
                      },
                    })}
                    placeholder="Middle Name"
                    // 1) Strip anything that’s not A–Z or a–z
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^A-Za-z]/g, "");
                    }}
                  />

                  {/* Last Name */}
                  <input
                    className="custom-input"
                    {...register("lastName", {
                      required: "Last Name is required",
                      pattern: {
                        value: /^[A-Za-z]+$/,
                        message: "First Name can contain only letters",
                      },
                    })}
                    type="text"
                    placeholder="Last Name"
                    required
                    // 1) Strip anything that’s not A–Z or a–z
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^A-Za-z]/g, "");
                    }}
                  />
                  {errors.lastName && (
                    <p className="text-red-500 text-xs mt-1 ml-1">
                      {errors.lastName.message}
                    </p>
                  )}
                </div>
              </div>

              {/* Gender Field */}
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Gender:
                </label>
                <select
                  className="custom-input"
                  id="gender"
                  {...register("gender", {
                    required: "Gender is required",
                  })}
                >
                  {Array.isArray(genderData) &&
                    genderData.map((option) => (
                      <option
                        key={option.gendeR_CODE}
                        value={option.gendeR_CODE}
                      >
                        {option.gender}
                      </option>
                    ))}
                </select>
                {errors.gender && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.gender.message}
                  </p>
                )}
              </div>

              {/* Date of Birth Field */}
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Date of Birth:
                </label>
                <input
                  className="custom-input"
                  type="date"
                  {...register("DOB", {
                    required: "Date of Birth is required",
                  })}
                />
                {errors.DOB && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.DOB.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="mb-4">
            <div className="grid grid-cols-5 gap-4 items-start">
              {/* Mobile Number Field */}
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Mobile Number:
                </label>
                <input
                  className="custom-input"
                  type="text"
                  maxLength={10} // Restrict input to 10 characters
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numeric input
                  }}
                  {...register("MobileNo", {
                    required: "Mobile Number is required",
                    pattern: {
                      value: /^[0-9]{10}$/, // Validate exactly 10 digits
                      message: "Enter a valid 10-digit mobile number",
                    },
                  })}
                  placeholder="Enter Mobile Number"
                />
                {errors.MobileNo && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.MobileNo.message}
                  </p>
                )}
              </div>

              {/* WhatsApp Number Field */}
              <div>
                <label className="block text-sm font-semibold mb-2">
                  WhatsApp Number:
                </label>

                <input
                  className="custom-input"
                  type="text"
                  maxLength={10} // Restrict input to 10 characters
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numeric input
                  }}
                  {...register("WhatsApp_No", {
                    pattern: {
                      value: /^[0-9]{10}$/, // Validate exactly 10 digits
                      message: "Enter a valid 10-digit mobile number",
                    },
                  })}
                  placeholder="Enter WhatsApp_No"
                />
                {errors.WhatsApp_No && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.WhatsApp_No.message}
                  </p>
                )}
              </div>

              {/* Email ID Field */}
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Email ID:
                </label>
                <input
                  className="custom-input"
                  type="email"
                  {...register("email", {
                    required: "Email ID is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter a valid email address",
                    },
                  })}
                  placeholder="Enter Email ID"
                />
                {errors.email && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.email.message}
                  </p>
                )}
              </div>

              {/* Identification Field */}
              <div className="col-span-2">
                <label className="block text-sm font-semibold mb-2">
                  Identification
                </label>
                <div>
                  <div className="flex flex-col sm:flex-row custom-input">
                    {/* Identification Type Dropdown */}
                    <div className="w-full sm:w-1/3">
                      <select
                        className="custom-input bg-gray-200 w-full"
                        {...register("identificationType", {
                          required: "Identification type is required",
                          onChange: (e) => {
                            const selectedType = e.target.value;
                            setValue("identificationType", selectedType); // Update the type
                            setValue("identificationNumber", ""); // Reset number field
                            clearErrors("identificationNumber"); // Clear previous errors
                          },
                        })}
                      >
                        {appointmentType === "V" || appointmentType === "VI"
                          ? idTypeData
                              .filter((option) => option.iD_CODE === "04")
                              .map((option) => (
                                <option
                                  key={option.iD_CODE}
                                  value={option.iD_CODE}
                                >
                                  {option.id}
                                </option>
                              ))
                          : idTypeData.map((option) => (
                              <option
                                key={option.iD_CODE}
                                value={option.iD_CODE}
                              >
                                {option.id}
                              </option>
                            ))}
                        {appointmentType !== "V" &&
                          appointmentType !== "VI" && (
                            <option value="05">Other</option>
                          )}
                      </select>
                    </div>

                    {/* Identification Number Input */}
                    <div className="w-full sm:w-2/3 mt-2 sm:mt-0 ml-0">
                      <input
                        className="custom-input uppercase"
                        type="text"
                        maxLength={
                          identificationType === "02"
                            ? 10
                            : identificationType === "04"
                            ? 12
                            : 100
                        }
                        {...register("identificationNumber", {
                          required: "Identification number is required",
                          validate: (value) => {
                            if (identificationType === "02") {
                              return (
                                /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value) ||
                                "Enter a valid PAN (ABCDE1234F format)"
                              );
                            }
                            if (identificationType === "04") {
                              return (
                                /^[0-9]{12}$/.test(value) ||
                                "Enter a valid 12-digit Aadhaar number"
                              );
                            }
                            return true;
                          },
                          onChange: (e) => {
                            const value = e.target.value.toUpperCase();
                            setValue("identificationNumber", value); // Update value
                            // Perform validation immediately
                            if (identificationType === "02") {
                              if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
                                setError("identificationNumber", {
                                  type: "manual",
                                  message:
                                    "Enter a valid PAN (ABCDE1234F format)",
                                });
                              } else {
                                clearErrors("identificationNumber");
                              }
                            }
                            if (identificationType === "04") {
                              if (!/^[0-9]{12}$/.test(value)) {
                                setError("identificationNumber", {
                                  type: "manual",
                                  message:
                                    "Enter a valid 12-digit Aadhaar number",
                                });
                              } else {
                                clearErrors("identificationNumber");
                              }
                            }
                          },
                        })}
                        placeholder={
                          identificationType === "05"
                            ? "Enter other identification details"
                            : "Enter identification number"
                        }
                      />
                    </div>
                  </div>
                  {/* Error Message */}
                  {errors.identificationNumber && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.identificationNumber.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Third Row */}
          <div className="mb-4">
            <div className="grid grid-cols-5 gap-4 items-start">
              {/* Relationship Field */}
              <div className="col-span-1">
                <label className="block text-sm font-semibold mb-2">
                  Relationship:
                </label>
                <select
                  className="custom-input"
                  id="relation"
                  {...register("relation", {
                    required: "relation is required",
                  })} // Update the correct state variable
                >
                  {/* <option value="">Select Relationship</option> */}
                  {relationData.map((option) => (
                    <option
                      key={option.relatioN_CODE}
                      value={option.relatioN_CODE}
                    >
                      {option.relation}
                    </option>
                  ))}
                </select>

                {errors.relation && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.relation.message}
                  </p>
                )}
              </div>

              {/* Father/Husband/Guardian Name Field */}
              <div className="col-span-2">
                <label className="block text-sm font-semibold mb-2">
                  Father, Husband, Guardian Name:
                </label>
                <input
                  className="custom-input -ml-4"
                  type="text"
                  {...register("fatherName", {
                    required: "Name is required",
                  })}
                  placeholder="Enter Name"
                />
                {errors.fatherName && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.fatherName.message}
                  </p>
                )}
              </div>

              {/* Category Field */}
              <div className="col-span-1">
                <label className="block text-sm font-semibold mb-2">
                  Category:
                </label>
                <select
                  className="custom-input w-full"
                  {...register("category", {
                    required: "Category is required",
                  })}
                >
                  <option value="">Category</option>
                  <option value="general">General</option>
                  <option value="sc">SC</option>
                  <option value="st">ST</option>
                  <option value="obc">OBC</option>
                </select>
                {errors.category && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.category.message}
                  </p>
                )}
              </div>

              {/* Religion Field */}
              <div className="col-span-1">
                <label className="block text-sm font-semibold mb-2">
                  Relegion:
                </label>
                <select
                  className="custom-input w-full"
                  {...register("Relegion", {
                    required: "Relegion is required",
                  })}
                >
                  <option value="">Relegion</option>
                  <option value="hindu">Hindu</option>
                  <option value="muslim">Muslim</option>
                  <option value="christian">Christian</option>
                  <option value="other">Other</option>
                </select>
                {errors.relegion && (
                  <p className="text-red-500 text-xs mt-1 ml-1">
                    {errors.relegion.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Address Fields */}
          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2">Address:</label>

            {/* Dropdowns for Country, District, State, Village/Town/City */}
            <div className="grid grid-cols-4 gap-2 mb-2">
              <div>
                <select
                  className="custom-input"
                  id="country"
                  {...register("country", {
                    required: "country is required",
                  })}
                >
                  <option value="">country</option>
                  <option value="India">India</option>
                </select>
              </div>

              <div>
                <select
                  className="custom-input"
                  id="state"
                  {...register("state", {
                    required: "state is required",
                  })}
                >
                  <option value="">State</option>
                  {stateOptions.map((option) => (
                    <option key={option.stateID} value={option.stateID}>
                      {option.stateName}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <select
                  className="custom-input"
                  id="district"
                  {...register("district", {
                    required: "district is required",
                  })}
                  // disabled={!selectedState} // Disable if no state is selected
                >
                  <option value="">District</option>
                  {districtOptions.map((option) => (
                    <option key={option.districtID} value={option.districtID}>
                      {option.districtName}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <input
                  className="custom-input"
                  type="village"
                  {...register("villageTownCity", {
                    required: "village is required",
                  })}
                  placeholder="Enter Village/Town/City"
                />
              </div>
            </div>

            {/* Inputs for House No., Landmark, Street, and Pincode */}
            <div className="grid grid-cols-3 gap-2 mb-2">
              <div>
                <input
                  className="custom-input"
                  type="text"
                  id="house"
                  {...register("house", {
                    required: "House/Flat is required",
                  })}
                  placeholder="House No./Flat"
                  required
                />
                {errors.house && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {errors.house.message}
                  </p>
                )}
              </div>
              <div>
                <input
                  className="custom-input"
                  id="landmark"
                  {...register("landmark", {
                    required: "Landmark is required",
                  })}
                  type="text"
                  placeholder="Landmark"
                  required
                />
                {errors.landmark && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {errors.landmark.message}
                  </p>
                )}
              </div>
              <div>
                <input
                  className="custom-input"
                  id="street"
                  {...register("street", {
                    required: "Street is required",
                  })}
                  type="text"
                  placeholder="Street"
                  required
                />
                {errors.street && (
                  <p className="text-red-500 text-sm mt-1 ml-1">
                    {errors.street.message}
                  </p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-3 gap-2 mb-2">
              <input
                className={`custom-input ${errors.pincode ? "is-invalid" : ""}`}
                type="tel"
                {...register("pincode", {
                  required: "Pincode is required",
                  pattern: {
                    value: /^[0-9]{6}$/, // This ensures it's a 6-digit number
                    message: "Pincode must be a 6-digit number",
                  },
                })}
                inputMode="numeric"
                placeholder="Pincode"
                maxLength={6}
                required
              />
              {errors.pincode && (
                <p className="text-red-500 text-sm mt-1 ml-1">
                  {errors.pincode.message}
                </p>
              )}
            </div>
          </div>

          <div className="col-span-3 md:col-span-10 3xl:col-span-10">
            <label className="text-md font-semibold">
              Upload Profile Picture
            </label>
            <div className="flex items-center gap-x-4 mt-2">
              {/* File Input */}
              <label className="text-md ms-4 font-semibold">
                <input
                  type="file"
                  name="uploadPhoto"
                  accept=".jpg,.jpeg,.png"
                  onChange={handleFileChange}
                  className="border rounded p-2"
                  required
                />
              </label>

              {/* Preview selected file */}
              {uploadPhoto && (
                <img
                  src={uploadPhoto}
                  alt="preview"
                  className="w-32 h-32 object-cover border rounded"
                />
              )}
            </div>
          </div>

          {/* Username, Password, and Confirm Password Row */}
          {!isPartySignUpModify && (
            <>
              <div className="mb-4">
                <div className="grid grid-cols-3 gap-4 items-start">
                  {/* Username Field */}
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Username:
                    </label>
                    <input
                      className="custom-input"
                      type="text"
                      {...register("username", {
                        required: "Username is required",
                        minLength: {
                          value: 4,
                          message:
                            "Username must be at least 4 characters long",
                        },
                      })}
                      placeholder="Enter Username"
                    />
                    {errors.username && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.username.message}
                      </p>
                    )}
                  </div>

                  {/* Password Field */}
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Password:
                    </label>
                    <div className="relative">
                      <input
                        className="custom-input pr-10"
                        type={showPassword ? "text" : "password"}
                        {...register("password", {
                          required: "Password is required",
                          minLength: {
                            value: 6,
                            message:
                              "Password must be at least 6 characters long",
                          },
                        })}
                        placeholder="Enter Password"
                      />
                      <button
                        type="button"
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <i className="fas fa-eye-slash"></i>
                        ) : (
                          <i className="fas fa-eye"></i>
                        )}
                      </button>
                    </div>
                    {errors.password && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.password.message}
                      </p>
                    )}
                  </div>

                  {/* Confirm Password Field */}
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Confirm Password:
                    </label>
                    <div className="relative">
                      <input
                        className="custom-input pr-10"
                        type={showConfirmPassword ? "text" : "password"}
                        {...register("confirmPassword", {
                          required: "Confirm Password is required",
                          validate: (value) =>
                            value === getValues("password") ||
                            "Passwords do not match",
                        })}
                        placeholder="Confirm Password"
                      />
                      <button
                        type="button"
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <i className="fas fa-eye-slash"></i>
                        ) : (
                          <i className="fas fa-eye"></i>
                        )}
                      </button>
                    </div>
                    {errors.confirmPassword && (
                      <p className="text-red-500 text-xs mt-1 ml-1">
                        {errors.confirmPassword.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Submit Button */}
          <div className="mt-6 flex justify-end">
            <button
              type="submit"
              className="bg-blue-500 text-white py-3 px-6 rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-400"
            >
              {isPartySignUpModify ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
      {showModal && (
        <RegistrationSuccessModal onClose={() => setShowModal(false)} />
      )}

      {/* EkycModal */}
      {isEkycModalOpen && (
        <EkycModal
          isOpen={isEkycModalOpen}
          onClose={(e) => {
            handleEkycModalClose(e);
          }}
          onAadhaarChange={handleAadhaarNumberChange}
        />
      )}
      {isMobileAdhaarModalOpen && (
        <MobileEmailModal
          onClose1={() => setisMobileAdhaarModalOpen(false)}
          mobileVerified={mobileVerified}
          emailVerified={emailVerified}
          whatsappVerified={whatsappVerified}
          onVerificationStatusChange={handleVerificationStatusChange}
          onVerificationComplete={onVerificationComplete} // Pass this function
          onSubmitModal={onSubmitModal}
          requireWhatsapp={requireWhatsapp}
          mobileNo={formData?.MobileNo || ""}
          emailAddr={formData?.email || ""}
          whatsappNo={formData?.WhatsApp_No || ""}
          firstName={formData?.firstName || ""}
        />
      )}
    </div>
  );
};

export default PartySignUpModal;
